import InteractionEvent, {
  type InteractionTargetType
} from './InteractionEvent';

export type SearchClearPlacement = 'header';

export type SearchClearTargetProperties = {
  placement: SearchClearPlacement;
  search_term: string;
};

type EventData = {
  gesture?: string;
  guestId?: string;
  isBot: boolean;
  placement: SearchClearPlacement;
  searchTerm: string;
};

class SearchClearInteractionEvent extends InteractionEvent<
  EventData,
  SearchClearTargetProperties
> {
  protected get targetType(): InteractionTargetType {
    return 'search_clear';
  }

  protected getTargetProperties(): SearchClearTargetProperties {
    return {
      placement: this.data.placement,
      search_term: this.data.searchTerm
    };
  }
}

export default SearchClearInteractionEvent;
